import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Collapse, Skeleton} from '@mui/material';
import {SimpleTextEditor} from 'components';
import {postedNoteActions} from 'store';
import {FindLoad, Images} from 'utils';

const GET_POSTED_NOTE = 'GET_POSTED_NOTE';

export const SessionPostedNote = () => {
    const dispatch = useDispatch();
    const sessionById = useSelector((state) => state.session.sessionById);
    const [collapsed, setCollapsed] = useState(false);
    const clientId = sessionById?.appt?.client?.id;
    const postedNote = useSelector((state) => state.postedNote.postedNote);
    const loader = FindLoad(GET_POSTED_NOTE);

    useEffect(() => {
        if (clientId) dispatch(postedNoteActions.getPostedNote(clientId));
    }, [clientId, dispatch]);

    if (loader?.length) {
        return (
            <div className="session-posted-note" style={{height: 78.5}}>
                <div className="session-posted-note__head">
                    <Skeleton variant="rounded" width={120} height={21}/>
                    <Skeleton variant="circular" width={20} height={21}/>
                </div>
                <div className="session-posted-note__body">
                    <Skeleton variant="text" width="90%"/>
                </div>
            </div>
        );
    }

    if (!postedNote?.content || postedNote?.content === '') {
        return null;
    }

    return (
        <div className="session-posted-note">
            <button
                type="button"
                className="session-posted-note__head"
                onClick={() => setCollapsed((prev) => !prev)}
                aria-expanded={!collapsed}
            >
                <span className="session-posted-note__title">
                    <img src={Images.postedNote} alt="pushPin"/>
                    Posted Note
                </span>
                <img
                    style={{
                        filter: 'brightness(0) saturate(100%) invert(49%) sepia(96%) saturate(347%) hue-rotate(1deg) brightness(95%) contrast(94%)',
                    }}
                    src={Images.chevronDown}
                    alt="toggle"
                    className={`session-posted-note__chevron${collapsed ? ' is-collapsed' : ''}`}
                />
            </button>

            {/* Same Collapse transition the MUI Accordion uses for the session goal list cards */}
            <Collapse in={!collapsed} timeout="auto">
                <div className="session-posted-note__body">
                    <SimpleTextEditor value={postedNote?.content} readOnly border={'none'}/>
                </div>
            </Collapse>
        </div>
    );
};
